<template>
  <Popup
    :value="value"
    :close-on-click-overlay="false"
    position="bottom"
    round
    class="withholding-auth-popup"
    @input="onInput"
  >
    <div class="withholding-auth">
      <div class="withholding-auth__handle" aria-hidden="true"></div>

      <div class="withholding-auth__header">
        <span class="withholding-auth__header-icon" aria-hidden="true">
          <span class="withholding-auth__header-icon-shape"></span>
        </span>
        <div class="withholding-auth__header-copy">
          <div class="withholding-auth__title">{{ $t('withholdingAuth.title') }}</div>
          <div class="withholding-auth__subtitle">{{ $t('withholdingAuth.subtitle') }}</div>
        </div>
      </div>

      <div class="withholding-auth__flow" aria-hidden="true">
        <span class="withholding-auth__wallet">
          <svg class="withholding-auth__wallet-svg" viewBox="0 0 64 52" width="64" height="52">
            <rect x="14" y="3" width="32" height="18" rx="7" fill="#ffffff" stroke="#1766F5" stroke-width="3.5" />
            <rect x="11" y="12" width="42" height="34" rx="7" fill="#ffffff" stroke="#1766F5" stroke-width="3.5" />
            <rect x="38" y="22" width="16" height="14" rx="6.5" fill="#ffffff" stroke="#1766F5" stroke-width="3.5" />
            <circle cx="46" cy="29" r="2.7" fill="#1766F5" />
          </svg>
        </span>
        <span class="withholding-auth__line">
          <span v-for="item in 5" :key="item" class="withholding-auth__line-dot"></span>
        </span>
        <span class="withholding-auth__dana">
          <img :src="genggoIcon" alt="Genggo" />
        </span>
      </div>

      <div class="withholding-auth__description">{{ $t('withholdingAuth.description') }}</div>

      <label class="withholding-auth__agree" @click="toggleAgree">
        <span class="withholding-auth__checkbox" :class="{ 'withholding-auth__checkbox--checked': agreed }">
          <van-icon v-if="agreed" name="success" />
        </span>
        <span class="withholding-auth__agree-text">
          <span>{{ $t('withholdingAuth.agreePrefix') }}</span>
          <span class="withholding-auth__agreement" @click.stop="openAgreement">{{ $t('withholdingAuth.agreement') }}</span>
          <span>.</span>
        </span>
      </label>

      <div class="withholding-auth__actions">
        <button type="button" class="withholding-auth__button withholding-auth__button--secondary" @click="onNotNow">{{ $t('withholdingAuth.notNow') }}</button>
        <button
          type="button"
          class="withholding-auth__button withholding-auth__button--primary"
          :class="{ 'withholding-auth__button--disabled': !agreed }"
          :disabled="!agreed"
          @click="onAuthorize"
        >
          {{ $t('withholdingAuth.authorize') }}
        </button>
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup, Icon } from 'vant';

export default {
  name: 'WithholdingAuthPopup',
  components: {
    Popup,
    'van-icon': Icon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agreed: false,
      genggoIcon: (process.env.BASE_URL || '/') + 'favicon.png'
    };
  },
  watch: {
    value(show) {
      if (show) {
        this.agreed = false;
      }
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);
    },
    toggleAgree() {
      this.agreed = !this.agreed;
    },
    openAgreement() {
      // 预留接入点：后续可跳转 Auto-debit Authorization Agreement 协议页。
    },
    onNotNow() {
      this.$emit('input', false);
    },
    onAuthorize() {
      if (!this.agreed) return;
      this.$emit('authorize');
    }
  }
};
</script>

<style lang="less" scoped>
.withholding-auth {
  padding: 30px 30px 40px;
  box-sizing: border-box;

  &__handle {
    margin: 0 auto 22px;
    width: 72px;
    height: 8px;
    border-radius: 4px;
    background: #E5E7EB;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 18px;
  }

  &__header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    flex: 0 0 auto;
    border-radius: 16px;
    background: #FFF1E0;
  }

  &__header-icon-shape {
    position: relative;
    width: 36px;
    height: 28px;
    border-radius: 7px;
    background: #F97316;
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      left: 7px;
      top: 8px;
      width: 18px;
      height: 3px;
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.7);
    }

    &::after {
      content: '';
      position: absolute;
      right: -7px;
      top: 50%;
      width: 12px;
      height: 14px;
      border-radius: 4px;
      background: #F97316;
      transform: translateY(-50%);
    }
  }

  &__header-copy {
    min-width: 0;
  }

  &__title {
    font-size: 34px;
    line-height: 44px;
    font-weight: 700;
    color: #0B0B12;
  }

  &__subtitle {
    margin-top: 6px;
    font-size: 26px;
    line-height: 36px;
    color: #6D7286;
  }

  &__flow {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 44px;
  }

  &__wallet {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 112px;
    height: 112px;
    flex: 0 0 auto;
    border-radius: 28px;
    background: #EEF2FF;
  }

  &__wallet-svg {
    width: 62px;
    height: 50px;
  }

  &__line {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__line-dot {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #E3E6EE;

    &:nth-child(3) {
      background: #F97316;
    }
  }

  &__dana {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 112px;
    height: 112px;
    flex: 0 0 auto;
    overflow: hidden;

    img {
      display: block;
      width: 139px;
      height: 139px;
      flex: 0 0 auto;
      transform: translateY(2.4px);
    }
  }

  &__description {
    margin-top: 36px;
    font-size: 26px;
    line-height: 40px;
    color: #6D7286;
    text-align: center;
  }

  &__agree {
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 16px;
    margin-top: 34px;
    cursor: pointer;
  }

  &__checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    flex: 0 0 auto;
    margin-top: 2px;
    border: 3px solid #C9CEDA;
    border-radius: 50%;
    color: #FFFFFF;
    font-size: 28px;
    box-sizing: border-box;
    transition: border-color 0.2s;

    &--checked {
      border-color: #1664F5;
      background: #1664F5;
    }
  }

  &__agree-text {
    flex: 1;
    min-width: 0;
    font-size: 26px;
    line-height: 38px;
    color: #111827;
    text-align: left;
  }

  &__agreement {
    color: #1664F5;
    font-weight: 600;
  }

  &__actions {
    display: flex;
    gap: 20px;
    margin-top: 40px;
  }

  &__button {
    flex: 1;
    height: 88px;
    border-radius: 14px;
    font-size: 30px;
    font-weight: 600;
    line-height: 84px;
    text-align: center;
    cursor: pointer;

    &--secondary {
      flex: 0 0 30%;
      border: 2px solid #D7DBE5;
      background: #FFFFFF;
      color: #111827;
    }

    &--primary {
      border: none;
      background: #1664F5;
      color: #FFFFFF;
    }

    &--disabled {
      background: #D8DCE6;
      cursor: not-allowed;
    }
  }
}
</style>
